module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-top-53dcb9d627350b09fe029db1e56bd8d5.svg";